// * import third party
import { EditIcon2, MoreIcon, TrashcanIcon } from '@assets/icons';
import { Box, Button, Text, Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';

// * import local
import { useConfirmModal } from '@store/useConfirmModal';
import { useApp } from '@pages/UploadMappingV2/context/AppContext';
import { formatDate } from '@helpers/utils';
import useMutateUploadMapping from '@pages/UploadMappingV2/hooks/mutate/useMutateUploadMapping';
import { ConfirmationState2 } from '@assets/images';
import { usePieceStore } from '@pages/UploadMappingV2/hooks/state/useAddProductSatuan';

function ActionHead({ allValue }) {
    const { set } = useConfirmModal();
    const { setDirectEditPiece } = usePieceStore();
    const { onOpenModalAddProductPiece } = useApp();
    const { deleteProductSatuan } = useMutateUploadMapping();

    const handleDelete = () => {
        set({
            isOpen: true,
            title: 'Hapus product?',
            desc: 'Data yang telah dituliskan akan hilang, perlu melakukan pengisian ulang untuk menambahkan atau menghubungkan produk.',
            btnLabelYes: 'Ya, Hapus',
            btnLabelNo: 'Kembali',
            ConfirmationStateImage: ConfirmationState2,
            onSubmit: () => deleteProductSatuan.mutate(allValue.id),
        });
    };

    const handleEdit = () => {
        setDirectEditPiece(allValue);
        onOpenModalAddProductPiece();
    };

    return (
        <Popover placement="bottom-start">
            <PopoverTrigger>
                <Button variant={'unstyled'} justifySelf={'end'} px={0} minW={'10px'}>
                    <MoreIcon />
                </Button>
            </PopoverTrigger>
            <PopoverContent>
                <PopoverBody w={'full'} _hover={{ bg: 'sagitarius.100' }}>
                    <Button
                        variant={'unstyled'}
                        onClick={handleEdit}
                        color={'sagitarius.500'}
                        w={'full'}
                        justifyContent={'start'}
                    >
                        <EditIcon2 size={18} />
                        Edit
                    </Button>
                </PopoverBody>
                <PopoverBody _hover={{ bg: 'danger.100' }}>
                    <Button variant={'unstyled'} onClick={handleDelete} color={'danger.500'}>
                        <TrashcanIcon size={18} />
                        Delete
                    </Button>
                </PopoverBody>
            </PopoverContent>
        </Popover>
    );
}

export const tableHeadLists = [
    {
        key: 'brand',
        title: 'Brand',
        width: '130px',
        tableDataList: ({ value }) => {
            return (
                <Box>
                    <Text>{value}</Text>
                </Box>
            );
        },
    },
    {
        key: 'name',
        title: 'Produk Paragon',
        width: '700px',
        tableDataList: ({ value }) => {
            return (
                <Box>
                    <Text>{value}</Text>
                </Box>
            );
        },
    },
    {
        key: 'barcode',
        title: 'Kode Produk di Paragon',
        width: '330px',
        tableDataList: ({ value }) => {
            return (
                <Box>
                    <Text>{value}</Text>
                </Box>
            );
        },
    },
    {
        key: 'code',
        title: 'Kode Produk di Toko',
        width: '330px',
        tableDataList: ({ value }) => {
            return (
                <Box>
                    <Text>{value}</Text>
                </Box>
            );
        },
    },
    {
        key: 'created_at',
        title: 'Date Created',
        width: '200px',
        tableDataList: ({ value }) => {
            return (
                <Box>
                    <Text>{formatDate(value, 'DD MMM YYYY, HH.mm')}</Text>
                </Box>
            );
        },
    },
    {
        key: 'action',
        title: 'Action',
        width: '30px',
        align: 'right',
        tableDataList: ({ allValue }) => {
            return <ActionHead allValue={allValue} />;
        },
    },
];
